import React, { useState } from 'react';
import propTypes from 'prop-types';
;
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import CreatableSelect from 'react-select/creatable';
import classNames from 'classnames';
import posed, { PoseGroup } from 'react-pose';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Control, Field, Label, Help } from 'src/ui/mui-ui-kit'

const HelperWrapper = posed.div({
  enter: {
    opacity: 1,
    x: 0,
  },
  exit: {
    opacity: 0,
    x: -10,
  },
});

export function UiSelect({
  id,
  value: initValue,
  name,
  fieldClassName,
  errorMessage,
  renderIcons,
  hasIcons,
  label,
  required,
  hideAsterisk,
  hideHelper,
  components,
  loadOptions,
  isCreatable,
  onChange,
  placeholder,
  defaultOptions,
  ...rest
}) {
  const [value, setValue] = useState();
  const [inputValue, setInputValue] = useState('');

  React.useEffect(() => {
    setValue(initValue);
  }, [initValue]);

  const icons = renderIcons();
  let iconsPosition = false;
  if (icons.length > 0) {
    if (icons.length === 2) {
      iconsPosition = true;
    } else {
      iconsPosition = hasIcons;
    }
  }
  const hasError = errorMessage ? 'danger' : '';
  const labelClassNames = classNames({
    'is-active':
      (Array.isArray(value) ? !!value.length : !!value) ||
      !!inputValue ||
      !!placeholder,
    'has-icons': !!iconsPosition && iconsPosition !== 'right',
  });
  const fieldClassNames = classNames('has-floating-label', fieldClassName);
  const containerClassNames = classNames('ui-select-container', {
    'is-danger': hasError,
  });
  const showAsterisk = required && !hideAsterisk;
  const onChangeFn = isCreatable ? creatableOnChange : onChange;

  let SelectComponent = loadOptions ? AsyncSelect : Select;
  if (isCreatable) {
    SelectComponent = CreatableSelect;
  }
  function convertToArr(incoming) {
    let myNewArray = [];
    if (Array.isArray(incoming)) {
      myNewArray = incoming;
    } else {
      myNewArray = Object.keys(incoming);
    }
    return myNewArray;
  }
  const handleKeyDown = event => {
    if (!inputValue || !isCreatable) {
      return;
    }
    // eslint-disable-next-line default-case
    if (event.key === 'Enter' || event.key === 'Tab') {
      // value.push(inputValue);
      if (
        (rest.type === 'text' || rest.type === 'url') &&
        rest.isMulti === true
      ) {
        const newValue = Array.isArray(convertToArr(value))
          ? [...value, { label: inputValue, value: inputValue }]
          : { label: inputValue, value: inputValue };
        onChange(newValue);
      } else {
        const newValue = Array.isArray(value)
          ? [...value, { label: inputValue, value: inputValue }]
          : { label: inputValue, value: inputValue };
        onChange(newValue);
      }
      setInputValue('');
      event.preventDefault();
    }
  };

  const handleBlur = () => {
    const label = inputValue?.trim() || '';
    if (!label) {
      return;
    }
    const option = { label, value: label };
    const newValue = [...(convertToArr(value) || []), option];
    setValue(newValue);
    setInputValue('');
    onChangeFn(newValue);
  };

  const handleInputChange = (textInput, { action }) => {
    if (action === 'input-change') {
      setInputValue(textInput);
    }
    if (isCreatable && action === 'input-blur') {
      handleBlur();
    }
  };

  const handleChange = selected => {
    setInputValue('');
    onChangeFn(selected);
  };

  function creatableOnChange(value) {
    setValue(value);
    setInputValue('');
    onChange(Array.isArray(value) ? [...(value || [])] : value);
  }

  return (
    <Field className={fieldClassNames}>
      {label && (
        <Label htmlFor={id} className={labelClassNames} hasTextColor={hasError}>
          {typeof label === 'string' ? <span>{label}</span> : label}
          {showAsterisk && (
            <span className="icon is-small has-text-danger asterisk">
              <FontAwesomeIcon icon={['fas', 'asterisk']} size="xs" />
            </span>
          )}
        </Label>
      )}
      <Control hasIcons={iconsPosition}>
        {icons}
        <SelectComponent
          id={id}
          value={value}
          name={name}
          className={containerClassNames}
          classNamePrefix="ui-select"
          required={required}
          components={{
            DropdownIndicator: () => (
              <div className="ui-select__indicator ui-select__dropdown-indicator">
                <FontAwesomeIcon icon={['fas', 'caret-down']} size="lg" />
              </div>
            ),
            ...components,
          }}
          loadOptions={loadOptions}
          isClearable={false}
          inputValue={inputValue}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          {...rest}
          onInputChange={handleInputChange}
          onChange={handleChange}
          defaultOptions={defaultOptions}
        />
        {!hideHelper && (
          <div className="helper-wrapper">
            <PoseGroup>
              {errorMessage && (
                <HelperWrapper key="helper">
                  <Help hasTextColor={hasError}>{errorMessage}</Help>
                </HelperWrapper>
              )}
            </PoseGroup>
          </div>
        )}
      </Control>
    </Field>
  );
}

UiSelect.defaultProps = {
  id: '',
  name: '',
  fieldClassName: '',
  errorMessage: '',
  renderIcons: () => [],
  hasIcons: '',
  hideAsterisk: false,
  hideHelper: false,
  components: {},
  isCreatable: false,
  placeholder: '',
  defaultOptions: undefined,
  label: '',
};

UiSelect.propTypes = {
  id: propTypes.string,
  name: propTypes.string,
  fieldClassName: propTypes.string,
  errorMessage: propTypes.string,
  placeholder: propTypes.string,
  renderIcons: propTypes.func,
  hasIcons: propTypes.string,
  label: propTypes.oneOfType([propTypes.node, propTypes.element]),
  hideAsterisk: propTypes.bool,
  hideHelper: propTypes.bool,
  components: propTypes.object,
  isCreatable: propTypes.bool,
  onChange: propTypes.func.isRequired,
  defaultOptions: propTypes.array,
  ...Select.propTypes,
};
